<!-- Navigation Bar -->
<app-navigation-bar></app-navigation-bar>

<app-password-guard *ngIf="!isPasswordVerified" (authenticated)="onPasswordVerified()"></app-password-guard>

<div class="container" [class.blocked]="!isPasswordVerified">
  <app-start-experiment></app-start-experiment>

  <app-ongoing-experiment-list></app-ongoing-experiment-list>

  <app-to-be-uploaded-experiment-list
    #uploadList
    (uploadRequested)="onUploadRequested($event)"
  ></app-to-be-uploaded-experiment-list>

  <!-- Excel Export Demo Section -->
  <div class="excel-export-demo-section" *ngIf="isAuthenticated && !isTokenExpired">
    <h3>📊 下載CSV</h3>
    
    <!-- Trial Sequence 1 Export -->
    <app-excel-export-button #exportButton1 [trialSequenceNumber]="1"></app-excel-export-button>
    
    <!-- Trial Sequence 2 Export -->
    <app-excel-export-button #exportButton2 [trialSequenceNumber]="2"></app-excel-export-button>
    
    <!-- Trial Sequence 3 Export -->
    <app-excel-export-button #exportButton3 [trialSequenceNumber]="3"></app-excel-export-button>

    <!-- Trial Sequence 4 Export -->
    <app-excel-export-button #exportButton4 [trialSequenceNumber]="4"></app-excel-export-button>

    <!-- Trial Sequence 5 Export -->
    <app-excel-export-button #exportButton5 [trialSequenceNumber]="5"></app-excel-export-button>

    <!-- Trial Sequence 6 Export -->
    <app-excel-export-button #exportButton6 [trialSequenceNumber]="6"></app-excel-export-button>
  </div>
</div>

<!-- Upload Data Popup -->
<app-upload-data
  [participantIdentifier]="selectedParticipantId"
  [isVisible]="showUploadPopup"
  (uploadCompleted)="onUploadCompleted(); uploadList.refreshList()"
  (uploadCancelled)="onUploadCancelled()"
></app-upload-data>
